var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-visa-procedure" }, [
    _c("header", { staticClass: "tls-home-banner" }, [
      _c(
        "div",
        {
          staticClass: "tls-home-banner--img",
          style: {
            backgroundImage:
              "url(" +
              _vm._.get(
                _vm.covidSanitaryMeasuresCmsData,
                "background_image.data.full_url"
              ) +
              ")"
          }
        },
        [
          _c("div", { staticClass: "tls-home-banner--content" }, [
            _c("div", { staticClass: "tls-home-text-group" }, [
              _c("h1", { staticClass: "tls-heading-1" }, [
                _vm._v(
                  _vm._s(
                    _vm._.get(_vm.covidSanitaryMeasuresCmsData, "primary_title")
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tls-simple-text -size-22 -color-white" },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm._.get(
                          _vm.covidSanitaryMeasuresCmsData,
                          "primary_sub_title"
                        )
                      ) +
                      "\n                    "
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tls-static-content tls-visa-procedure-content" },
      [
        _c("div", { staticClass: "tls-procedure-card-info" }, [
          _c("div", { staticClass: "tls-card-lg" }, [
            _c("div", { staticClass: "tls-simple-text -size-16" }, [
              _c("div", { staticClass: "tls-simple-text -size-16" }, [
                _vm._v(
                  _vm._s(
                    _vm._.get(_vm.covidSanitaryMeasuresCmsData, "card_title")
                  ) + "\n                    "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tls-simple-text -size-16" }, [
              _c(
                "div",
                { staticClass: "tls-simple-text -weight-bold -size-16" },
                [
                  _vm._v(
                    _vm._s(
                      _vm._.get(_vm.covidSanitaryMeasuresCmsData, "card_desc")
                    ) + "\n                    "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _vm._.get(_vm.covidSanitaryMeasuresCmsData, "primary_button_link")
          ? _c("div", { staticClass: "tls-visa-procedure-action" }, [
              _c("div", { staticClass: "tls-visa-procedure-action--slot" }, [
                _c("h2", { staticClass: "tls-heading-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm._.get(
                        _vm.covidSanitaryMeasuresCmsData,
                        "primary_button_title"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tls-visa-procedure-action--slot" }, [
                _c(
                  "a",
                  {
                    staticClass: "tls-button-primary",
                    attrs: {
                      href: _vm._.get(
                        _vm.covidSanitaryMeasuresCmsData,
                        "primary_button_link"
                      ),
                      target: "_blank",
                      rel: "noopener"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._.get(
                          _vm.covidSanitaryMeasuresCmsData,
                          "primary_button"
                        )
                      ) + "\n                "
                    )
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tls-visa-procedure-info" },
          _vm._l(_vm.contentSlotData, function(covidSanitaryMeasures_slot) {
            return _c("div", { staticClass: "tls-visa-procedure-info--item" }, [
              _c("div", { staticClass: "tls-img-title-desc" }, [
                _c("div", { staticClass: "tls-img-title-desc-heading" }, [
                  _c("img", {
                    staticClass: "tls-img-title-desc-img",
                    attrs: {
                      alt: _vm._.get(covidSanitaryMeasures_slot, "title"),
                      src: _vm._.get(
                        covidSanitaryMeasures_slot,
                        "image.data.url"
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", { staticClass: "tls-heading-2" }, [
                    _vm._v(
                      _vm._s(_vm._.get(covidSanitaryMeasures_slot, "title"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tls-img-title-desc-desc" }, [
                  _c("div", {
                    directives: [
                      {
                        name: "dompurify-html",
                        rawName: "v-dompurify-html",
                        value: _vm._.get(
                          covidSanitaryMeasures_slot,
                          "description"
                        ),
                        expression:
                          " _.get(covidSanitaryMeasures_slot, 'description')"
                      }
                    ],
                    staticClass: "tls-simple-text -size-16"
                  })
                ])
              ])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm._.get(_vm.covidSanitaryMeasuresCmsData, "bottom_button_link")
          ? _c("div", { staticClass: "tls-visa-procedure-action" }, [
              _c("div", { staticClass: "tls-visa-procedure-action--slot" }, [
                _c("h2", { staticClass: "tls-heading-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm._.get(
                        _vm.covidSanitaryMeasuresCmsData,
                        "bottom_button_title"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tls-visa-procedure-action--slot" }, [
                _c(
                  "a",
                  {
                    staticClass: "tls-button-primary",
                    attrs: {
                      href: _vm._.get(
                        _vm.covidSanitaryMeasuresCmsData,
                        "bottom_button_link"
                      )
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._.get(
                          _vm.covidSanitaryMeasuresCmsData,
                          "bottom_button"
                        )
                      ) + "\n                "
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-procedure-card-info--decoration" }, [
      _c("div", { staticClass: "tls-decoration-vertical-lines -blue" }, [
        _c("div", { staticClass: "tls-line1" }),
        _vm._v(" "),
        _c("div", { staticClass: "tls-line2" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }